import React, { createContext, useContext, useState } from "react";

/**
 * Returns a number whose value is limited to the given range.
 *
 * Example: limit the output of this computation to between 0 and 255
 * (x * 255).clamp(0, 255)
 *
 * @param {Number} min The lower boundary of the output range
 * @param {Number} max The upper boundary of the output range
 * @returns A number in the range [min, max]
 * @type Number
 */
const clamp = (num, min, max) => {
  return Math.min(Math.max(num, min), max);
};

const defaultValues = {
  currentStep: 0,
  setStep: (step) => {},
};

const StepsContext = createContext(defaultValues);

const StepsProvider = ({ children, maxStep }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const hasNextStep = () => currentStep + 1 <= maxStep;
  const hasPrevStep = () => currentStep < maxStep - 1 && currentStep > 0;

  console.log("HAS PREV STEP", currentStep);

  const onNext = () => {
    setCurrentStep(clamp(currentStep + 1, 0, maxStep - 1));
  };

  const onPrev = () => {
    setCurrentStep(clamp(currentStep - 1, 0, maxStep - 1));
  };

  const resetStep = () => {
    setCurrentStep(0);
  };

  return (
    <StepsContext.Provider
      value={{
        currentStep,
        setStep: setCurrentStep,
        hasNextStep,
        hasPrevStep,
        onNext,
        onPrev,
        resetStep,
      }}
    >
      {children}
    </StepsContext.Provider>
  );
};

export const useSteps = () => {
  const context = useContext(StepsContext);
  if (!context) throw new Error("Steps must be a parent component");
  return context;
};

export default StepsProvider;
